import styles from './TitleOverlay.module.scss';

interface TitleOverlayProps {
    /** The crucible's name. */
    readonly title: string;
    /** The crucible's description, under its name. */
    readonly description: string;
}

/** The gathering's page header: the crucible's name and description over the scene. */
export function TitleOverlay({ title, description }: TitleOverlayProps): JSX.Element {
    return (
        <div className={styles.titleOverlay}>
            <h1 className={styles.title}>{title}</h1>
            <p className={styles.subtitle}>{description}</p>
        </div>
    );
}
